module.exports = __webpack_public_path__ + "img/raytracer.d408f19d.png";